import { render, staticRenderFns } from "./broadcastBar.vue?vue&type=template&id=065aa76b&scoped=true"
import script from "./broadcastBar.vue?vue&type=script&lang=js"
export * from "./broadcastBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065aa76b",
  null
  
)

export default component.exports